import ImageWithDisplayName from "@/common/components/ImageWithDisplayName";
import ResumeBox from "@/common/components/ResumeBox";
import { formatDateTime } from "@/common/utils/formatters";
import { bankingDepositStatus } from "@/features/privateCompanies/constants/bankingDeposits/bankingDepositStatus.constant";
import { BankingDepositsData } from "@/features/privateCompanies/types/bankingDeposits/bankingDeposits.type";
import { UserRoundIcon } from "lucide-react";

interface BankingDepositDataProps {
  bankingDeposit?: BankingDepositsData;
  isLoading?: boolean;
}

const BankingDepositData = ({ bankingDeposit, isLoading }: BankingDepositDataProps) => {
  return (
    <div className="flex flex-col gap-1.5">
      <p className="text-lg">
        Dados do Depósito
      </p>

      <div className="flex flex-col gap-3">
        <div className="flex gap-3">
          <ResumeBox
            padding="small"
            boxClassName="flex-1 shadow-lg"
            label="Status"
            value={(bankingDeposit?.status && bankingDepositStatus[bankingDeposit.status]) || '--'}
            isLoading={isLoading}
            testId="banking_deposit_status"
          />

          <ResumeBox
            padding="small"
            boxClassName="flex-1 shadow-lg"
            label="Data e hora da solicitação"
            value={(bankingDeposit?.created_at && formatDateTime(new Date(bankingDeposit.created_at))) || '--'}
            isLoading={isLoading}
            testId="banking_deposit_created_at"
          />
        </div>

        <ResumeBox
          padding="small"
          boxClassName="shadow-lg"
          label="Autor"
          value={(bankingDeposit?.requested_by && (
            <ImageWithDisplayName
              displayName={bankingDeposit?.requested_by?.full_name || '--'}
              imageUrl={bankingDeposit?.requested_by?.profile_picture?.url}
              placeholderIcon={UserRoundIcon}
            />
          )) || 'Tcard'}
          isLoading={isLoading}
          testId="banking_deposit_requested_by"
        />
      </div>
    </div>
  );
}

export default BankingDepositData;
